import WaysToHelpItem from './item';
import type { WaysToHelpContentItem } from '@jlg-website/database/types';
import type { EmblaViewportRefType } from 'embla-carousel-react';

type WaysToHelpServerProps = {
  items: WaysToHelpContentItem[];
  emblaRef?: EmblaViewportRefType;
};

export function WaysToHelpServer({ items, emblaRef }: WaysToHelpServerProps) {
  return (
    <div className="overflow-hidden" ref={emblaRef}>
      <div className="flex gap-4 translate-x-[calc(-85vw_-_0.75rem)] @lg:translate-x-[calc(-52vw_-_2rem)] transform-gpu">
        {items.map((item, i) => (
          <WaysToHelpItem key={i} {...item} />
        ))}
      </div>
    </div>
  );
}
